import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import store from '../../../redux/store';
import { validateTableauAccess } from '../../../helpers/tableau-dashboard';
import TableauDashboard from '../../../components/Common/Tableau';

const styles = makeStyles(theme => ({
  divLight: {
    borderBottom: '1px solid #D9D9D9',
  },
  divDark: {
    borderBottom: '1px solid #5C5C5C',
  },
  tableauContainer: {
    [theme.breakpoints.down('md')]: {
      overflow: 'auto',
    },
  },
}));

const TableauTab = props => {
  const classes = styles();
  const theme = useTheme();
  const options = validateTableauAccess();
  const { user } = store.getState();
  let orgId = 0;

  if (user?.organization) {
    orgId = user?.organization?.id;
  }

  const [option] = useState(options ? options.find(o => o.default) : null);
  const { eventId } = props;

  return (
    <div style={{ height: '100%' }} className={classes.tableauContainer}>
      {options ? (
        <>
          <div
            style={{
              padding: '15px',
              display: 'flex',
              alignItems: 'flex-start',
              justifyContent: 'flex-start',
            }}
            className={theme.palette.type === 'light' ? classes.divLight : classes.divDark}
          >
            You must be logged-in to Tableau to see any graphs available to you.
          </div>
          <TableauDashboard url={option ? option.url : null} orgId={orgId} eventId={eventId} />
        </>
      ) : (
        <div style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <p>There are no graphs available for your organization</p>
        </div>
      )}
    </div>
  );
};

TableauTab.propTypes = {
  eventId: PropTypes.object.isRequired,
};

export default TableauTab;
